import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const LSIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="LS" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#55BA07"
        fillRule="evenodd"
        d="M0 8h16v4H0V8Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 4h16v4H0V4Z"
        clipRule="evenodd"
      />
      <Path
        fill="#3D58DB"
        fillRule="evenodd"
        d="M0 0h16v4H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#1D1D1D"
        d="M7.938 3.667c.134 0 .247.084.291.203.409.091.706.367.706.82 0 .328-.159.728-.402 1.002l1.219 1.194.3-.098.448.68A6.6 6.6 0 0 1 7.967 8 6.07 6.07 0 0 1 5.5 7.468l.382-.582.307.102 1.13-1.275c-.253-.275-.418-.686-.419-1.024 0-.468.317-.747.747-.828a.313.313 0 0 1 .29-.194ZM7.763 7.65l.063.098h.52l-.202-.222-.381.124Zm-.702-.04.05.094.433.04-.177-.216-.306.082Zm1.454 0 .064.11.443-.05L8.85 7.5l-.335.11Zm-2.11-.11.047.078.406.08-.146-.225-.307.067Zm2.792.047.055.082.372-.082-.144-.17-.283.17Zm-1.513 0 .396-.104-.049-.09h-.513l.166.195Zm-1.756-.11.218.076v-.12l-.218.044Zm1.08.076.278-.085-.077-.101-.327-.041.127.227Zm1.3-.153.12.149.33-.115-.041-.077-.41.043Zm1.51.025v.08l.251-.08-.105-.145-.147.145Zm-.824-.097.124.152.298-.152-.083-.046-.339.046ZM6.368 7.4l.277-.076-.055-.105-.333-.08.111.261Zm3.164-.246.18.172.175-.172-.055-.07-.3.07Zm-3.658.17h.247l-.12-.177-.127.177Zm1.751-3.206c-.261.07-.4.253-.4.572 0 .365.18.706.4.883V4.119Zm.625 1.445a1.18 1.18 0 0 0 .386-.872c0-.31-.136-.49-.386-.564v1.436Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
